var _path, _g, _g2, _g3, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClassicModeIllustrationRtl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 226,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M400 .573H0v224.581h400z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.682,
    height: 121.788,
    rx: 8.939,
    transform: "matrix(-1 0 0 1 137.43 51.97)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m119.381 86.777-.002-.002c-1.092-1.121-2.939-1.125-4.066.002l-3.356 3.356-.003.002c-1.117 1.09-1.096 2.938.005 4.069 1.092 1.12 2.94 1.124 4.067-.003l3.355-3.355.003-.003c1.121-1.092 1.124-2.939-.003-4.066Zm-39.16 39.16-.002-.002c-1.092-1.121-2.94-1.125-4.066.002l-3.356 3.356-.003.002c-1.12 1.092-1.124 2.94.003 4.067l.002.002c1.092 1.121 2.94 1.125 4.066-.002l3.356-3.356.003-.003c1.12-1.092 1.124-2.939-.003-4.066Zm-7.424-39.16-.003.003c-1.12 1.091-1.124 2.939.003 4.066l3.356 3.355.002.003c1.089 1.117 2.938 1.097 4.069-.005 1.12-1.092 1.124-2.94-.003-4.066l-3.356-3.356-.002-.002c-1.092-1.121-2.94-1.125-4.066.002Zm39.16 39.16-.003.003c-1.12 1.092-1.124 2.939.003 4.066l3.356 3.356.002.002c1.089 1.118 2.938 1.097 4.069-.005 1.121-1.092 1.124-2.939-.003-4.066l-3.355-3.356-.003-.002c-1.092-1.121-2.939-1.125-4.066.002Zm9.458-12.981h6.331c1.587 0 2.887-1.3 2.887-2.887s-1.3-2.886-2.887-2.886h-6.331a2.896 2.896 0 0 0-2.887 2.886c0 1.587 1.3 2.887 2.887 2.887Zm-56.983 0h6.331c1.587 0 2.886-1.3 2.886-2.887s-1.299-2.886-2.886-2.886h-6.331a2.895 2.895 0 0 0-2.887 2.886c0 1.587 1.3 2.887 2.887 2.887Zm34.543-28.213v-6.331c0-1.587-1.3-2.887-2.886-2.887a2.896 2.896 0 0 0-2.886 2.887v6.331c0 1.587 1.3 2.887 2.886 2.887 1.587 0 2.886-1.3 2.886-2.887Zm0 56.984v-6.332c0-1.587-1.3-2.886-2.886-2.886a2.895 2.895 0 0 0-2.886 2.886v6.332c0 1.587 1.3 2.886 2.886 2.886a2.895 2.895 0 0 0 2.886-2.886Z",
    fill: "#2196F3",
    fillOpacity: 0.08,
    stroke: "#fff",
    strokeWidth: 0.559
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.089 95.173c-8.224 0-14.898 6.674-14.898 14.898 0 8.223 6.674 14.897 14.898 14.897 8.223 0 14.898-6.674 14.898-14.897 0-8.224-6.675-14.898-14.898-14.898Zm-4.037 21.289-5.349-5.349a1.483 1.483 0 0 1 0-2.1 1.484 1.484 0 0 1 2.101 0l4.305 4.29 10.25-10.249a1.484 1.484 0 0 1 2.101 0 1.483 1.483 0 0 1 0 2.1l-11.308 11.308c-.566.581-1.52.581-2.1 0Z",
    fill: "#2196F3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.682,
    height: 121.788,
    rx: 8.939,
    transform: "matrix(-1 0 0 1 357.542 51.97)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.604 148.06a4.47 4.47 0 0 0-4.47-4.469h-55.866a4.47 4.47 0 0 0-4.469 4.469v13.408a4.47 4.47 0 0 0 4.469 4.469h55.866a4.47 4.47 0 0 0 4.47-4.469V148.06Z",
    fill: "#000",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36.871,
    height: 4.469,
    rx: 2.235,
    transform: "matrix(-1 0 0 1 334.078 152.529)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.324 92.194a4.19 4.19 0 0 0-4.19-4.19h-55.866a4.19 4.19 0 0 0-4.19 4.19V105.6a4.19 4.19 0 0 0 4.19 4.19h55.866a4.19 4.19 0 0 0 4.19-4.19V92.194Z",
    stroke: "#000",
    strokeOpacity: 0.15,
    strokeWidth: 0.559
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.314 95.172a3.725 3.725 0 0 1 0 7.449 3.727 3.727 0 0 1-3.725-3.724 3.726 3.726 0 0 1 3.725-3.725Zm0 6.704a2.978 2.978 0 0 0 2.979-2.98 2.98 2.98 0 1 0-2.979 2.98Z",
    fill: "#666"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 21.229,
    height: 4.469,
    rx: 2.235,
    transform: "matrix(-1 0 0 1 329.609 96.663)",
    fill: "#000",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.324 64.26a4.19 4.19 0 0 0-4.19-4.19h-55.866a4.19 4.19 0 0 0-4.19 4.19v13.408a4.19 4.19 0 0 0 4.19 4.19h55.866a4.19 4.19 0 0 0 4.19-4.19V64.26Z",
    stroke: "#000",
    strokeOpacity: 0.15,
    strokeWidth: 0.559
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.314 67.239a3.725 3.725 0 0 1 0 7.449 3.726 3.726 0 0 1-3.725-3.725 3.726 3.726 0 0 1 3.725-3.724Zm0 6.704a2.978 2.978 0 0 0 2.979-2.98 2.98 2.98 0 1 0-2.979 2.98Z",
    fill: "#666"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 21.229,
    height: 4.469,
    rx: 2.235,
    transform: "matrix(-1 0 0 1 329.609 68.73)",
    fill: "#000",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.324 120.126a4.19 4.19 0 0 0-4.19-4.19h-55.866a4.19 4.19 0 0 0-4.19 4.19v13.408a4.19 4.19 0 0 0 4.19 4.19h55.866a4.19 4.19 0 0 0 4.19-4.19v-13.408Z",
    stroke: "#000",
    strokeOpacity: 0.15,
    strokeWidth: 0.559
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M336.314 123.104a3.725 3.725 0 1 1-.002 7.448 3.725 3.725 0 0 1 .002-7.448Zm0 6.704a2.979 2.979 0 1 0 0-5.96 2.979 2.979 0 0 0 0 5.96Z",
    fill: "#666"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 21.229,
    height: 4.469,
    rx: 2.235,
    transform: "matrix(-1 0 0 1 329.609 124.595)",
    fill: "#000",
    fillOpacity: 0.6
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#f)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.682,
    height: 121.788,
    rx: 8.939,
    transform: "matrix(-1 0 0 1 292.738 51.97)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.799 148.06a4.47 4.47 0 0 0-4.469-4.469h-55.866a4.47 4.47 0 0 0-4.47 4.469v13.408a4.47 4.47 0 0 0 4.47 4.469h55.866a4.47 4.47 0 0 0 4.469-4.469V148.06Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 36.871,
    height: 4.469,
    rx: 2.235,
    transform: "matrix(-1 0 0 1 269.274 152.529)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.519 92.194a4.19 4.19 0 0 0-4.189-4.19h-55.866a4.19 4.19 0 0 0-4.19 4.19V105.6a4.19 4.19 0 0 0 4.19 4.19h55.866a4.19 4.19 0 0 0 4.189-4.19V92.194Z",
    stroke: "#000",
    strokeOpacity: 0.15,
    strokeWidth: 0.559
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)",
    fill: "#666"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.509 95.172a3.725 3.725 0 0 1 0 7.449 3.726 3.726 0 0 1 0-7.449Zm0 6.704a2.979 2.979 0 1 0 0-5.959 2.98 2.98 0 1 0 0 5.959Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.509 100.759a1.863 1.863 0 1 1 .001-3.725 1.863 1.863 0 0 1-.001 3.725Z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 21.229,
    height: 4.469,
    rx: 2.235,
    transform: "matrix(-1 0 0 1 264.805 96.663)",
    fill: "#000",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.519 64.26a4.19 4.19 0 0 0-4.189-4.19h-55.866a4.19 4.19 0 0 0-4.19 4.19v13.408a4.19 4.19 0 0 0 4.19 4.19h55.866a4.19 4.19 0 0 0 4.189-4.19V64.26Z",
    stroke: "#000",
    strokeOpacity: 0.15,
    strokeWidth: 0.559
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.509 67.239a3.725 3.725 0 0 1 0 7.449 3.725 3.725 0 0 1 0-7.449Zm0 6.704a2.98 2.98 0 1 0 .002-5.959 2.98 2.98 0 0 0-.002 5.959Z",
    fill: "#666"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 21.229,
    height: 4.469,
    rx: 2.235,
    transform: "matrix(-1 0 0 1 264.805 68.73)",
    fill: "#000",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.52 120.126a4.19 4.19 0 0 0-4.19-4.19h-55.866a4.19 4.19 0 0 0-4.19 4.19v13.408a4.19 4.19 0 0 0 4.19 4.19h55.866a4.19 4.19 0 0 0 4.19-4.19v-13.408Z",
    stroke: "#000",
    strokeOpacity: 0.15,
    strokeWidth: 0.559
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.509 123.104a3.726 3.726 0 1 1-3.725 3.725 3.727 3.727 0 0 1 3.725-3.725Zm0 6.704a2.979 2.979 0 1 0-2.98-2.979 2.978 2.978 0 0 0 2.98 2.979Z",
    fill: "#666"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 21.229,
    height: 4.469,
    rx: 2.235,
    transform: "matrix(-1 0 0 1 264.805 124.595)",
    fill: "#000",
    fillOpacity: 0.6
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M228.402 156.013a1.25 1.25 0 1 0 0-2.5v2.5Zm-91.209-46.826a1.25 1.25 0 0 0 0 1.767l7.955 7.955a1.25 1.25 0 0 0 1.768-1.767l-7.071-7.072 7.071-7.071a1.25 1.25 0 1 0-1.768-1.767l-7.955 7.955Zm46.047 23.23h1.25-1.25Zm0 0h1.25-1.25Zm45.162 21.096h-22.816v2.5h22.816v-2.5Zm-67.509-44.693h-22.816v2.5h22.816v-2.5Zm23.597 23.597c0-13.032-10.565-23.597-23.597-23.597v2.5c11.652 0 21.097 9.446 21.097 21.097h2.5Zm21.096 21.096c-11.651 0-21.096-9.445-21.096-21.096h-2.5c0 13.032 10.564 23.596 23.596 23.596v-2.5Z",
    fill: "#A6D5FA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(-1 0 0 1 340.783 94.427)",
    d: "M0 0h8.939v8.939H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(-1 0 0 1 340.783 66.494)",
    d: "M0 0h8.939v8.939H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(-1 0 0 1 340.783 122.359)",
    d: "M0 0h8.939v8.939H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(-1 0 0 1 275.978 94.427)",
    d: "M0 0h8.939v8.939H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(-1 0 0 1 275.978 66.494)",
    d: "M0 0h8.939v8.939H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "matrix(-1 0 0 1 275.978 122.359)",
    d: "M0 0h8.939v8.939H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 43.575,
    y: 41.913,
    width: 105.028,
    height: 144.134,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.117,
    in: "SourceAlpha",
    result: "effect1_dropShadow_106_1188"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.235
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.235
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_1188"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.469
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.793
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_106_1188",
    result: "effect2_dropShadow_106_1188"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.117
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.587
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_106_1188",
    result: "effect3_dropShadow_106_1188"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect3_dropShadow_106_1188",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 263.687,
    y: 41.913,
    width: 105.028,
    height: 144.134,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.117,
    in: "SourceAlpha",
    result: "effect1_dropShadow_106_1188"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.235
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.235
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_1188"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.469
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.793
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_106_1188",
    result: "effect2_dropShadow_106_1188"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.117
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.587
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_106_1188",
    result: "effect3_dropShadow_106_1188"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect3_dropShadow_106_1188",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "f",
    x: 198.883,
    y: 41.913,
    width: 105.028,
    height: 144.134,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.117,
    in: "SourceAlpha",
    result: "effect1_dropShadow_106_1188"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.235
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.235
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_1188"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.469
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.793
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_106_1188",
    result: "effect2_dropShadow_106_1188"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.117
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.587
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_106_1188",
    result: "effect3_dropShadow_106_1188"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect3_dropShadow_106_1188",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassicModeIllustrationRtl);
export default __webpack_public_path__ + "static/media/classic-mode-illustration-rtl.f36d47c2198b31ba9faf4b1978e34e94.svg";
export { ForwardRef as ReactComponent };